module.exports = __webpack_public_path__ + "img/for-tech-lovers.ce78041b.jpg";